export const honeycombData = {
  contentArray: [
    {
      ID: 1,
      tabTitle: 'System Change',
      leftColumnTitle: 'System variables',
      scenarioParameters: {
        systemScale: 'Market share: ~40%',
        systemScaleSub:
          'Large shift to reuse within a highly shared infrastructure',
        infrastructure: 'Pooled packaging',
        packaging: 'Pooled packaging',
        returnRate: '95% (enabling packaging to be reused ~15 times)',
      },
      chartURL:
        'https://content.ellenmacarthurfoundation.org/m/86c9f70249b3c60/original/Scenario-1-Data-Vis.png',
      imageCaption:
        'Final transport leg from ‘sorting and cleaning’ to ‘filling’',
      mapURL:
        'https://content.ellenmacarthurfoundation.org/m/766ecebc97b7a2e4/original/Honeycomb-S1-map.jpg',
      vimeoURL:
        'https://player.vimeo.com/video/858925722?background=1&amp;badge=0&amp;autoplay=1&amp;loop=1&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    },
    {
      ID: 2,
      tabTitle: 'Collaborative Action',
      leftColumnTitle: 'System variables',
      scenarioParameters: {
        systemScale: 'Market share: ~10%',
        systemScaleSub:
          'Possible through big volume shifts to reuse and some sharing of infrastructure',
        infrastructure: 'Pooled packaging',
        packaging: 'Medium',
        returnRate: '90% (enabling packaging to be reused ~10 times)',
      },
      chartURL:
        'https://content.ellenmacarthurfoundation.org/m/7c979eb2ffa16a8/original/Scenario-2-Data-Vis.png',
      imageCaption:
        'Final transport leg from ‘sorting and cleaning’ to ‘filling’',
      mapURL:
        'https://content.ellenmacarthurfoundation.org/m/2efc5c03c6ff4f10/original/Honeycomb-S2-map.jpg',
      vimeoURL:
        'https://player.vimeo.com/video/858926532?background=1&amp;badge=0&amp;autoplay=1&amp;loop=1&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    },
    {
      ID: 3,
      tabTitle: 'Fragmented Effort',
      leftColumnTitle: 'System variables',
      scenarioParameters: {
        systemScale: 'Market share: ~2%',
        systemScaleSub: 'Due to low volumes and fragmented infrastructure',
        infrastructure: 'Bespoke packaging',
        packaging: 'High',
        returnRate: '80% (enabling packaging to be reused ~5 times)',
      },
      chartURL:
        'https://content.ellenmacarthurfoundation.org/m/3743ea191732d95e/original/Scenario-3-Data-Vis.png',
      mapURL:
        'https://content.ellenmacarthurfoundation.org/m/21ac51832880fa0f/original/Honeycomb-S3-map.jpg',
      imageCaption:
        'Final transport leg from ‘sorting and cleaning’ to ‘filling’',
      vimeoURL:
        'https://player.vimeo.com/video/858926809?background=1&amp;badge=0&amp;autoplay=1&amp;loop=1&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    },
  ],
  visualisationButtons: ['Scenario visual', 'Scenario modelling results'],
};
